const NAMESPACE = "attachmentDisplayComponent";

const KEYS = {
    fileNameLabel: "fileNameLabel",
    uploadedByLabel: "uploadedByLabel",
    uploadTimestampLabel: "uploadTimestampLabel",
    statusLastUpdatedByLabel: "statusLastUpdatedByLabel",
    statusLastUpdatedTimeLabel: "statusLastUpdatedTimeLabel",
    openInNewWindowLinkText: "openInNewWindowLinkText",
    unsupportedFileTypeLine1: "unsupportedFileTypeLine1",
    pdfUnsupportedLine1: "pdfUnsupportedLine1",
    pdfUnsupportedLinkText: "pdfUnsupportedLinkText",
    pdfUnsupportedLine2: "pdfUnsupportedLine2",
    pdfNotAvailableLine1: "pdfNotAvailableLine1",
    imageContentAltText: "imageContentAltText",
    currentStatusLabel: "currentStatusLabel",
    unsupportedFileTypeDownloadLinkText: "unsupportedFileTypeDownloadLinkText",
    noAttachmentSelectedText: "noAttachmentSelectedText"
};
const MESSAGES = {
    [KEYS.fileNameLabel]: { value: "File Name:", comment: "Label for the file name of the attachment" },
    [KEYS.uploadedByLabel]: {
        value: "Uploaded By:",
        comment: "Label for the info about the user who uploaded the attachment"
    },
    [KEYS.uploadTimestampLabel]: {
        value: "Upload Timestamp:",
        comment: "Label for the timestamp at which the attachment was uploaded"
    },
    [KEYS.statusLastUpdatedByLabel]: {
        value: "Status Last Updated By:",
        comment: "Label indicating the user who last updated the attachment's approval status"
    },
    [KEYS.statusLastUpdatedTimeLabel]: {
        value: "Status Last Updated Timestamp",
        comment: "Label for the last time at which the approval status was updated"
    },
    [KEYS.openInNewWindowLinkText]: {
        value: "Open file in new window",
        comment: "Text for a link that opens the contents of the attachment in its own window"
    },
    [KEYS.unsupportedFileTypeLine1]: {
        value: "Sorry, we currently do not support in-browser viewing of .{fileType} files.",
        comment:
            "Text informing the user that we can't display the contents of their attachment in the browser due to its file type"
    },
    [KEYS.pdfUnsupportedLine1]: {
        value: "It looks like your browser cannot display .pdf files within a page.",
        comment:
            "Part 1 of text explaining to the user that their browser doesn't support viewing PDF files within another page"
    },
    [KEYS.pdfUnsupportedLinkText]: {
        value: "To download your file, click here.",
        comment: "Link text that allows the user to download their PDF file when it cannot be viewed in the browser"
    },
    [KEYS.pdfUnsupportedLine2]: {
        value: "Otherwise, try a different browser or install an extension that allows your browser to open .pdf files.",
        comment:
            "Part 2 of text explaining to user that they can try to install an extension to let their browser display PDF files"
    },
    [KEYS.pdfNotAvailableLine1]: {
        value: "There was an error displaying this file in the browser.",
        comment: "Appears in place of the PDF when the file cannot be retrieved to display in the browser."
    },
    [KEYS.imageContentAltText]: {
        value: "{fileName} - uploaded by {uploadUserDisplay}",
        comment:
            "Image alt-text that tells the user the file name and uploader if the image-type attachment can't be loaded"
    },
    [KEYS.currentStatusLabel]: {
        value: "Current Status:",
        comment: "Label for the attachment's current approval status"
    },
    [KEYS.unsupportedFileTypeDownloadLinkText]: {
        value: "Please click here to download your file.",
        comment: "Link text inviting the user to download their file since they cannot view it in the browser"
    },
    [KEYS.noAttachmentSelectedText]: {
        value: "No attachment has been selected.",
        comment: "Text to display when no attachment has been selected to display in the display component"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
